import { Mic } from "lucide-react";
import { useDictation } from "@/hooks/useDictation";

// Drop-in voice-to-text button. Calls onAppend(text) with each finalized phrase.
export function MicButton({ onAppend, className = "", size = 18, testid = "dictate-btn" }) {
  const { supported, listening, toggle } = useDictation({ onFinal: onAppend });
  if (!supported) return null;
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={toggle}
      aria-label={listening ? "Stop voice typing" : "Start voice typing"}
      aria-pressed={listening}
      title={listening ? "Listening… tap to stop" : "Tap to speak"}
      className={`inline-flex items-center justify-center rounded-full transition-smooth ${
        listening ? "bg-[#B97978] text-white" : "bg-[#F7F2EA] text-[#291B2D] hover:bg-[#EFE7DA]"
      } ${className}`}
    >
      <Mic size={size} className={listening ? "animate-pulse" : ""} />
      {listening && <span className="pointer-events-none absolute inset-0 rounded-full ring-2 ring-[#B97978]/50 animate-ping" />}
    </button>
  );
}
